module.exports = __webpack_public_path__ + "static/img/peach-m.f591360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/peach-m.jpg
// module id = 8uxE
// module chunks = 0